/***
 *
 *   AUTH LAYOUT
 *   Layout for the signup/signin pages
 *
 **********/

import { type ComponentType } from 'react';
import { Footer, useLocation } from 'components/lib';

interface AuthLayoutProps {
  children: ComponentType<Record<string, unknown>>;
  data?: Record<string, unknown>;
}

export function AuthLayout(props: AuthLayoutProps) {
  const location = useLocation();
  const isSignupVerificationPage = location.pathname === '/register/verify';
  const isAuthEntryPage = location.pathname === '/login';

  if (isSignupVerificationPage) {
    return (
      <main>
        <props.children {...props.data} />
      </main>
    );
  }

  return (
    <main>
      <div className={`auth-dashboard-panel${isAuthEntryPage ? ' auth-dashboard-panel--entry' : ''}`}>
        <div className="auth-dashboard-content">
          <props.children {...props.data} />
        </div>
      </div>
      <Footer />
    </main>
  );
}
